// extracted by mini-css-extract-plugin
export default {"button":"YO1VW","wrapper":"uUJe8","label":"LRA7R","bubble":"rLcbQ"};